import { Endpoints } from '@/core/models/endpoints.interface';

export const TEAM_TAX_DISCOUNT_TYPE_ENDPOINTS: Pick<Endpoints, 'GET_ALL'> = {
   GET_ALL: () => '/team-tax-discount-types',
};
